import React from "react";
import { useHistory } from "react-router-dom";
import { SetupFlow } from "../../../components/SetupFlow/SetupFlow";
import { AddStandardPayoutMethodManual } from "./AddStandardPayoutMethodManual";
import { AddStandardPayoutMethodType } from "./AddStandardPayoutMethodType";

type Props = {
  basePath: string;
  onBack: () => void;
  onFinish: () => void;
};

export const AddStandardPayoutMethod: React.FC<Props> = ({
  basePath,
  onBack,
  onFinish
}) => {
  const history = useHistory();

  return (
    <SetupFlow
      basePath={basePath}
      routes={[
        {
          path: "/type",
          component: AddStandardPayoutMethodType,
          onBack: onBack,
          onNext: context => {
            if (context?.manual) {
              history.push(basePath + "/manual");
            } else {
              onFinish();
            }
          }
        },
        {
          path: "/manual",
          component: AddStandardPayoutMethodManual,
          onBack: () => {
            history.push(basePath + "/type");
          },
          onNext: onFinish
        }
      ]}
    />
  );
};
